<template>
  <div>
    <h3>{{ $t("overview.network.artists.header") }}</h3>
    <vca-row>
      <div class="clickable" @click="navCrews">
        {{ $t("overview.network.artists.total") }}
      </div>
      <div class="bold">{{ artists.length }}</div>
    </vca-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ArtistsDashlet",
  methods: {
    navCrews() {
      this.$router.push({ path: "/network/artists" });
    },
  },
  computed: {
    ...mapGetters({
      artists: "artists/list",
    }),
  },
};
</script>
